import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    public companyId: string = undefined;
    public companyInfo: any = {};
    public userName: string = undefined;
    public showEleganceModal: boolean = false;
    public imgUrlElegance: string = undefined;
    public visibleDrawer: boolean = false;
    // 交互发票弹框 选择
    public drawerSelect: string = undefined;
    public fileList: Array<any> = [];

    public invoiceList: any[] = [];
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/CompanyPublic/Modules.State.ts